import { create } from 'zustand'

/** localStorage key: the newest changelog version this browser has seen. */
export const SEEN_KEY = 'ostrel.changelog.seen'

// Storage can be missing or throw (private mode, blocked site data) — the
// dot then simply shows until the page is visited in this session.
function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Per-browser convenience only; nothing to recover.
  }
}

interface ChangelogState {
  seen: string | null
  markSeen: (version: string) => void
}

export const useChangelogStore = create<ChangelogState>((set) => ({
  seen: read(SEEN_KEY),
  markSeen: (version) => {
    write(SEEN_KEY, version)
    set({ seen: version })
  },
}))

/** Unread = there is a newest entry and it isn't the one last seen. */
export function hasUnread(newest: string | undefined, seen: string | null): boolean {
  return newest !== undefined && newest !== seen
}
